/*
  NS V2 How to Sit (sections/nb-ns-v2-how-to-sit.liquid)

  The poster and play button render server-side; nothing from YouTube/Vimeo
  loads until the play button is clicked, at which point the button is
  replaced by an autoplaying embed on top of the poster.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nb-ns-v2-hts]';
  var PLAY_SELECTOR = '[data-nb-ns-v2-hts-play]';

  function embedUrl(type, id) {
    var encodedId = encodeURIComponent(id);

    if (type === 'youtube') {
      return 'https://www.youtube-nocookie.com/embed/' + encodedId + '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodedId + '?autoplay=1';
    }
    return null;
  }

  function play(root) {
    var src = embedUrl(root.dataset.videoType, root.dataset.videoId || '');
    if (src === null) {
      return;
    }

    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = root.querySelector(PLAY_SELECTOR).getAttribute('aria-label') || '';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;

    root.querySelector(PLAY_SELECTOR).replaceWith(iframe);
    iframe.focus();
  }

  function init(root) {
    if (root.nbNsV2HtsInit === true) {
      return;
    }
    root.nbNsV2HtsInit = true;

    var button = root.querySelector(PLAY_SELECTOR);
    if (button === null) {
      return;
    }

    button.addEventListener('click', function () {
      play(root);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
